import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            本周最受欢迎的影片和剧集
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span className={`text-2xl font-heading ${
                    item.rank === 1 ? 'text-accent-500' :
                    item.rank === 2 ? 'text-secondary-500' :
                    'text-primary-400'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-medium text-foreground-500">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">
                  {item.category}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1">
                <i className="ri-star-fill text-sm text-accent-400"></i>
                <span className="text-sm font-bold text-foreground-800">
                  {item.score}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}